import {
  FaBuilding,
  FaCity,
  FaHome,
  FaFileSignature,
  FaPaintRoller,
  FaCouch,
  FaPencilRuler,
  FaWrench,
  FaBorderAll,
  FaLayerGroup,
  FaUtensils,
  FaTintSlash,
  FaBolt,
  FaHammer,
  FaShieldAlt,
  FaSun,
  FaWindowMaximize,
} from "react-icons/fa";

export const services = [
  {
    id: 1,
    slug: "construction",
    icon: FaBuilding,

    title: "Construction Services",

    metaTitle: "Residential Construction Services | AZ Construction",

    metaDescription: "Professional residential construction services in Indore with quality materials, expert engineers, and timely project delivery.",

    shortDescription:
      "Residential, commercial and industrial construction solutions.",

    bannerImage: "/images/services/construction-banner.png",

    image: "/images/services/construction.png",

    overview:
      "AZ Construction provides complete construction solutions for residential, commercial and industrial projects. From planning and design to execution and delivery, we ensure quality workmanship, safety standards and timely completion.",

    features: [
      "Residential Construction",
      "Commercial Construction",
      "Industrial Construction",
      "Turnkey Projects",
      "Renovation & Remodeling",
      "Project Management",
    ],

    benefits: [
      "Expert Construction Team",
      "Quality Materials",
      "On-Time Delivery",
      "Cost Effective Solutions",
      "Transparent Process",
      "Safety Compliance",
    ],

    process: [
      "Consultation",
      "Planning & Design",
      "Construction Execution",
      "Quality Inspection",
      "Project Delivery",
    ],

    projects: [
      {
        title: "Luxury Villa Project",
        image: "/images/projects/project-1.png",
      },
      {
        title: "Commercial Office Complex",
        image: "/images/projects/project-2.png",
      },
      {
        title: "Apartment Development",
        image: "/images/projects/project-3.png",
      },
    ],

    faqs: [
      {
        question: "How long does construction take?",
        answer:
          "Project duration depends on size and complexity.",
      },
      {
        question: "Do you provide turnkey construction?",
        answer:
          "Yes, we offer complete turnkey project solutions.",
      },
    ],
  },

  // Property Development

  {
    id: 2,
    slug: "property-development",
    icon: FaCity,

    title: "Property Development",

    metaTitle: "Property Development & Real Estate | AZ Construction",

    metaDescription: "Expert property development services in Indore ensuring maximum ROI and long-term value creation.",

    shortDescription:
      "Land development and project management services.",

    bannerImage: "/images/services/development-banner.png",

    image: "/images/services/development.png",

    overview:
      "We develop residential and commercial properties with proper planning, infrastructure and long-term value creation.",

    features: [
      "Land Development",
      "Township Planning",
      "Infrastructure Development",
      "Project Management",
      "Investment Consultancy",
      "Project Execution",
    ],

    benefits: [
      "Maximum ROI",
      "Strategic Planning",
      "Expert Development Team",
      "Risk Reduction",
      "Market Insights",
      "Long-Term Growth",
    ],

    process: [
      "Site Analysis",
      "Planning",
      "Approval Process",
      "Development",
      "Project Handover",
    ],

    projects: [],
    faqs: [],
  },

  // Property Dealer

  {
    id: 3,
    slug: "property-dealer",
    icon: FaHome,

    title: "Property Dealer",

    metaTitle: "Property Dealer in Indore | AZ Construction",

    metaDescription: "Buy, sell, or invest in residential and commercial properties with trusted property consultants in Indore.",

    shortDescription:
      "Property buying, selling and investment consultancy.",

    bannerImage: "/images/services/property-banner.png",

    image: "/images/services/property.png",

    overview:
      "Professional property consultation and brokerage services for buyers, sellers and investors.",

    features: [
      "Residential Sales",
      "Commercial Leasing",
      "Investment Advisory",
      "Property Valuation",
      "Legal Verification",
    ],
    benefits: [
      "Fair Market Prices",
      "Verified Properties",
      "Hassle-Free Transactions",
      "Expert Guidance",
      "Negotiation Support",
    ],
    process: [
      "Requirement Analysis",
      "Property Shortlisting",
      "Site Visits",
      "Negotiation",
      "Documentation & Registry",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you help with property loans?",
        answer: "Yes, we provide assistance and guidance for property financing."
      },
      {
        question: "Are your properties legally verified?",
        answer: "Absolutely. We conduct thorough legal due diligence on all properties."
      }
    ],
  },

  // Liaisoning

  {
    id: 4,
    slug: "liaisoning-services",
    icon: FaFileSignature,

    title: "Liaisoning Services",

    metaTitle: "Liaisoning Services | AZ Construction",

    metaDescription: "Professional liaisoning services for approvals, permissions, and documentation in construction projects.",

    shortDescription:
      "Government approvals and documentation support.",

    bannerImage: "/images/services/liaisoning-banner.png",

    image: "/images/services/liaisoning.png",

    overview:
      "We handle approvals, permissions, NOCs and government documentation efficiently.",

    features: [
      "Building Permissions",
      "TNCP Approvals",
      "RERA Registration",
      "Municipal Approvals",
      "NOC Clearances",
    ],
    benefits: [
      "Faster Approvals",
      "100% Legal Compliance",
      "Time Saving",
      "Transparent Process",
      "Expert Consultants",
    ],
    process: [
      "Document Collection",
      "File Preparation",
      "Department Submission",
      "Follow-up",
      "Final Approval",
    ],
    projects: [],
    faqs: [
      {
        question: "How long do building permissions take?",
        answer: "Timelines vary by department, but our expertise ensures the fastest possible processing."
      },
      {
        question: "Do you handle commercial project approvals?",
        answer: "Yes, we handle liaisoning for both residential and commercial projects."
      }
    ],
  },

  // ---------------------------------------------------------
  // LOCATION SEO PAGES (INDORE)
  // ---------------------------------------------------------
  
  // Construction in Indore
  {
    id: 101,
    slug: "construction-services-company-in-indore",
    isLocationPage: true,
    icon: FaBuilding,
    title: "Construction Services Company in Indore",
    metaTitle: "Top Construction Services Company in Indore | AZ Construction",
    metaDescription: "Looking for the best construction services company in Indore? AZ Construction offers premium residential, commercial, and industrial construction with unmatched quality.",
    shortDescription: "Leading residential, commercial and industrial construction company based in Indore.",
    bannerImage: "/images/services/construction-banner.png",
    image: "/images/services/construction.png",
    overview: "As a top-rated construction services company in Indore, AZ Construction provides end-to-end building solutions. Whether it's a luxury residential villa or a large-scale commercial complex in Indore, we ensure absolute quality and timely delivery.",
    features: [
      "Residential Construction in Indore",
      "Commercial Building Projects",
      "Industrial Construction Solutions",
      "Turnkey Construction Contracts",
      "Renovation & Remodeling",
      "Expert Project Management",
    ],
    benefits: [
      "Local Indore Market Expertise",
      "Premium Quality Materials",
      "Strict On-Time Delivery",
      "Cost-Effective Construction",
      "100% Transparent Process",
      "Highest Safety Standards",
    ],
    process: [
      "Initial Consultation",
      "Site Inspection in Indore",
      "Architectural Design & Approval",
      "Construction Execution",
      "Final Quality Handover",
    ],
    projects: [
      {
        title: "Luxury Villa Project in Indore",
        image: "/images/projects/project-1.png",
      },
      {
        title: "Commercial Office Complex",
        image: "/images/projects/project-2.png",
      },
    ],
    faqs: [
      {
        question: "Why choose AZ Construction in Indore?",
        answer: "We are recognized as a trusted construction company in Indore with years of experience delivering high-quality residential and commercial projects."
      },
      {
        question: "Do you build turnkey projects in Indore?",
        answer: "Yes, we handle everything from planning to final handover for turnkey projects across Indore."
      },
    ],
  },

  // Property Development in Indore
  {
    id: 102,
    slug: "property-development-company-in-indore",
    isLocationPage: true,
    icon: FaCity,
    title: "Property Development Company in Indore",
    metaTitle: "Best Property Development Company in Indore | AZ Construction",
    metaDescription: "Partner with the most reliable property development company in Indore. We maximize ROI through strategic land development and expert project management.",
    shortDescription: "Strategic land development and project management services in Indore.",
    bannerImage: "/images/services/development-banner.png",
    image: "/images/services/development.png",
    overview: "AZ Construction is a premier property development company in Indore. We specialize in transforming raw land into high-value residential townships and commercial hubs, carefully planned to meet the growing infrastructure needs of Indore.",
    features: [
      "Land Development in Indore",
      "Township Planning & Execution",
      "Commercial Infrastructure",
      "End-to-End Project Management",
      "Real Estate Investment Consultancy",
      "Joint Venture Developments",
    ],
    benefits: [
      "Maximum ROI on Indore Properties",
      "Strategic Urban Planning",
      "Expert Development Team",
      "Regulatory Risk Reduction",
      "Deep Local Market Insights",
      "Long-Term Asset Growth",
    ],
    process: [
      "Site Feasibility Analysis",
      "Master Planning",
      "Government Approval Process",
      "Infrastructure Development",
      "Project Completion & Handover",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you develop commercial properties in Indore?",
        answer: "Yes, we handle the development of large-scale commercial and residential properties across Indore."
      }
    ],
  },

  // Property Dealer in Indore
  {
    id: 103,
    slug: "property-dealer-in-indore",
    isLocationPage: true,
    icon: FaHome,
    title: "Property Dealer in Indore",
    metaTitle: "Trusted Property Dealer in Indore | Buy & Sell Properties",
    metaDescription: "Looking for a reliable property dealer in Indore? AZ Construction provides expert real estate consulting, buying, and selling services for premium properties.",
    shortDescription: "Expert property buying, selling, and investment consultancy in Indore.",
    bannerImage: "/images/services/property-banner.png",
    image: "/images/services/property.png",
    overview: "Finding the right real estate investment can be challenging. As a highly trusted property dealer in Indore, we offer expert brokerage and consultation to help buyers, sellers, and investors navigate the dynamic Indore property market with confidence.",
    features: [
      "Residential Property Sales",
      "Commercial Real Estate Leasing",
      "Indore Investment Advisory",
      "Accurate Property Valuation",
      "100% Legal Verification",
    ],
    benefits: [
      "Access to Premium Indore Listings",
      "Legally Verified Properties",
      "Hassle-Free Transactions",
      "Expert Market Guidance",
      "Strong Negotiation Support",
    ],
    process: [
      "Requirement Analysis",
      "Property Shortlisting",
      "Guided Site Visits in Indore",
      "Price Negotiation",
      "Documentation & Registry Support",
    ],
    projects: [],
    faqs: [
      {
        question: "Can you help me find a house in Indore?",
        answer: "Absolutely! As a leading property dealer in Indore, we have an extensive portfolio of verified residential properties."
      },
      {
        question: "Are your listed properties legally verified?",
        answer: "Yes, we conduct thorough legal due diligence on all properties before listing them to ensure complete safety for our clients."
      }
    ],
  },

  // Liaisoning Services in Indore
  {
    id: 104,
    slug: "liaisoning-services-company-in-indore",
    isLocationPage: true,
    icon: FaFileSignature,
    title: "Liaisoning Services Company in Indore",
    metaTitle: "Expert Liaisoning Services Company in Indore | AZ Construction",
    metaDescription: "AZ Construction is a trusted liaisoning services company in Indore offering seamless government approvals, TNCP, RERA, and building permissions.",
    shortDescription: "Expert government approvals, TNCP, RERA, and documentation support in Indore.",
    bannerImage: "/images/services/liaisoning-banner.png",
    image: "/images/services/liaisoning.png",
    overview: "Navigating government regulations requires local expertise. As a dedicated liaisoning services company in Indore, we efficiently manage all bureaucratic processes, including building permissions, NOCs, and municipal approvals to keep your project moving forward without delays.",
    features: [
      "Indore Building Permissions",
      "TNCP Approvals",
      "RERA Project Registration",
      "Municipal Corporation Approvals",
      "Fire & Environment NOCs",
    ],
    benefits: [
      "Significantly Faster Approvals",
      "100% Legal & Regulatory Compliance",
      "Saves Valuable Time & Effort",
      "Highly Transparent Process",
      "Experienced Local Consultants",
    ],
    process: [
      "Initial Document Collection",
      "Technical File Preparation",
      "Department Level Submission",
      "Active Follow-up in Indore Departments",
      "Procurement of Final Approval",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you handle TNCP approvals in Indore?",
        answer: "Yes, we specialize in TNCP approvals, RERA registration, and local municipal clearances."
      },
      {
        question: "How long does it take to get building permissions?",
        answer: "Timelines depend on the specific project and department, but our local expertise in Indore ensures the fastest possible processing time."
      }
    ],
  },

  // Interior Designing
  {
    id: 5,
    slug: "interior-designing",
    icon: FaPencilRuler,
    title: "Interior Designing",
    metaTitle: "Interior Designing Services in Indore | AZ Construction",
    metaDescription: "Professional interior designing services in Indore. Modern 3D designs, modular kitchens, wardrobes, and custom space planning.",
    shortDescription: "Bespoke interior design, 3D space planning, and premium home styling.",
    bannerImage: "/images/services/interior-banner.png",
    image: "/images/services/interior.png",
    overview: "AZ Construction offers creative and premium interior designing services. From conceptual blueprints to 3D visualization and final execution, we create elegant spaces that blend aesthetics with functionality.",
    features: [
      "Bespoke Space Planning",
      "3D Architectural Visualizations",
      "Modular Kitchens & Wardrobes",
      "Custom Furniture & Finishes",
      "Lighting & Ceiling Designs",
      "Commercial & Retail Styling",
    ],
    benefits: [
      "Tailored Creative Designs",
      "Optimal Space Utilization",
      "Premium Quality Materials",
      "Experienced Design Architects",
      "Cost-Effective Planning",
      "Seamless Execution",
    ],
    process: [
      "Consultation & Budgeting",
      "Concept Mood Boards",
      "3D Layout & Rendering",
      "Material Sourcing & Design Approval",
      "On-site Execution & Fit-out",
      "Handover & Styling",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you design both residential and commercial spaces?",
        answer: "Yes, we handle complete interior design and styling for residential villas, apartments, corporate offices, and retail showrooms."
      },
      {
        question: "How long does a typical interior project take?",
        answer: "Timelines depend on the scale of work, but a standard 3BHK home interior takes about 45 to 60 days from final design approval."
      }
    ],
  },

  // Renovation & Remodeling
  {
    id: 6,
    slug: "renovation-services",
    icon: FaHammer,
    title: "Renovation & Remodeling",
    metaTitle: "Home & Commercial Renovation Services in Indore | AZ Construction",
    metaDescription: "Premium renovation and remodeling services in Indore. Give your home, kitchen, or office a modern structural transformation.",
    shortDescription: "Complete home, kitchen, bathroom, and structural renovation solutions.",
    bannerImage: "/images/services/renovation-banner.png",
    image: "/images/services/renovation.png",
    overview: "Give your property a modern, premium transformation. We specialize in structural repairs, room expansions, layout restructuring, bathroom remodeling, and exterior elevation upgrades.",
    features: [
      "Full Home Remodeling",
      "Bathroom & Toilet Upgrades",
      "Kitchen Modernization",
      "Structural Repairs & Strengthening",
      "Exterior Elevation Makeovers",
      "Office & Commercial Restructuring",
    ],
    benefits: [
      "Significantly Increases Property Value",
      "Modernizes Outdated Layouts",
      "Improves Structural Integrity & Safety",
      "Hassle-Free Turnkey Execution",
      "Top-Tier Construction Standards",
      "Custom Space Optimization",
    ],
    process: [
      "Structural & Site Assessment",
      "Design & Budgeting Planning",
      "Dismantling & Debris Disposal",
      "Masonry & Structural Reinforcement",
      "Finishing & Painting",
      "Final Handover Inspection",
    ],
    projects: [],
    faqs: [
      {
        question: "Can I remodel only specific sections of my home?",
        answer: "Yes, we offer sectional renovation services for individual kitchens, bathrooms, living areas, or exterior elevations."
      },
      {
        question: "What safety measures do you follow during structural renovation?",
        answer: "We employ experienced structural engineers, install adequate propping/support, and follow strict safety compliance to maintain structural stability."
      }
    ],
  },

  // False Ceiling (POP, PVC & Gypsum)
  {
    id: 7,
    slug: "false-ceiling",
    icon: FaBorderAll,
    title: "False Ceiling (POP, PVC & Gypsum)",
    metaTitle: "False Ceiling Services (POP, PVC & Gypsum) | AZ Construction",
    metaDescription: "Elegant POP, PVC, and Gypsum false ceiling design and installation services in Indore. Hidden ambient lighting and acoustic insulation.",
    shortDescription: "Designer POP, PVC, and Gypsum false ceilings with custom lighting.",
    bannerImage: "/images/services/false-ceiling-banner.png",
    image: "/images/services/false-ceiling.png",
    overview: "Enhance the look of your rooms with our premium false ceiling services. We design and install Plaster of Paris (POP), PVC panel, and Gypsum board ceilings featuring hidden LED wiring, sound-insulation, and custom architectural designs.",
    features: [
      "Custom POP Ceiling Designs",
      "Moisture-Proof PVC Panel Ceilings",
      "Gypsum Board Ceiling Systems",
      "Ambient LED & Spot Lighting Setup",
      "Acoustic & Thermal Insulation",
      "Decorative Borders & Molding",
    ],
    benefits: [
      "Excellent Thermal Insulation",
      "Effective Sound Dampening",
      "Concealed Electrical Wires & AC Ducts",
      "Stunning Modern Aesthetic & Lighting",
      "Durable & Long-Lasting Finishes",
      "Fast & Clean Installation",
    ],
    process: [
      "Ceiling Height & Level Survey",
      "Lighting & Design Selection",
      "GI Metal Frame Installation",
      "Board/Panel Fixing",
      "Joint Filling & Finishing Coat",
      "Electrical Wiring & Light Mounting",
    ],
    projects: [],
    faqs: [
      {
        question: "Which material is better: POP, PVC, or Gypsum?",
        answer: "Gypsum is faster and cleaner to install. POP allows for intricate customized curves and designs. PVC is highly recommended for moisture-prone areas like kitchens and bathrooms."
      },
      {
        question: "Does a false ceiling decrease room height?",
        answer: "It drops the ceiling height by about 5 to 8 inches, which is perfectly fine for standard rooms and provides excellent space for concealed wiring."
      }
    ],
  },

  // Flooring Services
  {
    id: 8,
    slug: "flooring-services",
    icon: FaLayerGroup,
    title: "Flooring Services",
    metaTitle: "Tiling & Marble Flooring Services in Indore | AZ Construction",
    metaDescription: "Professional flooring services in Indore. Vitrified tiling, Italian marble installation, wooden flooring, and granite polishing.",
    shortDescription: "Marble, vitrified tile, wooden, and granite flooring installations.",
    bannerImage: "/images/services/flooring-banner.png",
    image: "/images/services/flooring.png",
    overview: "Step onto perfection. We provide premium flooring installation services with high precision, ensuring robust levelling, seamless joint alignments, and durable bindings for residential and commercial layouts.",
    features: [
      "Vitrified Tile Installation",
      "Italian & Indian Marble Laying",
      "Laminate & Hardwood Flooring",
      "Granite & Kota Stone Laying",
      "Heavy-Duty Industrial Epoxy",
      "Marble & Granite Mirror Polishing",
    ],
    benefits: [
      "Flawless Leveling & Alignment",
      "High Resistance to Wear & Stains",
      "Wide Selection of Premium Designs",
      "Enhanced Visual Space Appeal",
      "Experienced Tiling Specialists",
      "Low Long-Term Maintenance",
    ],
    process: [
      "Subfloor Leveling & Cleaning",
      "Material Dry Laying & Pattern Check",
      "High-Bond Adhesive Application",
      "Precise Tile/Stone Laying",
      "Grouting & Joint Sealing",
      "Curing & Final Machine Polish",
    ],
    projects: [],
    faqs: [
      {
        question: "Which flooring is best for high-traffic living rooms?",
        answer: "Double-charged vitrified tiles or polished granite are ideal due to their high scratch resistance and ease of cleaning."
      },
      {
        question: "Do you supply the tiles and marble?",
        answer: "We can source materials directly from leading wholesale dealers at discounted rates, or install materials supplied by you."
      }
    ],
  },

  // Painting Services
  {
    id: 9,
    slug: "painting-services",
    icon: FaPaintRoller,
    title: "Painting Services",
    metaTitle: "Professional House Painting Services in Indore | AZ Construction",
    metaDescription: "Top-quality interior & exterior painting services in Indore. Wall putty, texture coatings, wood polishing, and waterproof wall coatings.",
    shortDescription: "Premium interior, exterior, texture, and protective painting.",
    bannerImage: "/images/services/paint-banner.png",
    image: "/images/services/paint.png",
    overview: "Bring colors to life. Our professional painting services cover interior walls, exterior weather-protection coatings, designer texture walls, putty application, and luxury wood polishing for a beautiful, long-lasting look.",
    features: [
      "Premium Interior Wall Emulsions",
      "Weatherproof Exterior Coatings",
      "Designer Accent & Texture Walls",
      "Wall Putty & Primer Preparations",
      "Wood Polishing & PU Coatings",
      "Damp-Proof Waterproofing Basecoats",
    ],
    benefits: [
      "Vibrant, Washable Paints",
      "Fungus & Moisture Resistant",
      "Flawless, Smooth Finishing",
      "Certified Skilled Painter Crew",
      "Clean & Dust-Free Execution",
      "Protection from Harsh Weather",
    ],
    process: [
      "Furniture Masking & Cover-up",
      "Sanding & Crack Filling",
      "Double Coat Putty & Primer",
      "Precision Emulsion Application",
      "Quality Check & Color Matching",
      "Site Cleanup & Walkthrough",
    ],
    projects: [],
    faqs: [
      {
        question: "What paint brands do you use?",
        answer: "We use premium products from trusted brands like Asian Paints, Berger, and Nerolac, depending on your preferred finish and budget."
      },
      {
        question: "Do you offer dust-free painting?",
        answer: "Yes, we use dustless vacuum sanding machines to minimize dust particles and ensure a cleaner environment."
      }
    ],
  },

  // Home Decor & Styling
  {
    id: 10,
    slug: "home-decor",
    icon: FaCouch,
    title: "Home Decor & Styling",
    metaTitle: "Premium Home Decor & Styling in Indore | AZ Construction",
    metaDescription: "Give your home a luxurious interior styling. Wallpaper fitting, customized curtains, designer lighting, and space staging.",
    shortDescription: "Curated wallpapers, customized curtains, designer lights, and furniture styling.",
    bannerImage: "/images/services/decor-banner.png",
    image: "/images/services/decor.png",
    overview: "It's all in the details. Our home styling experts curate custom wallpapers, bespoke curtains, decorative lighting fixtures, rugs, and art pieces to add personality and luxury to your rooms.",
    features: [
      "Designer Wallpaper Installation",
      "Customized Curtains & Blinds",
      "Aesthetic Ambient & Profile Lights",
      "Theme-Based Room Staging",
      "Custom Furniture & Furnishings",
      "Art & Artifact Consultation",
    ],
    benefits: [
      "Cohesive Design Themes",
      "Personalized Styling Identity",
      "Access to Exclusive Decor Vendors",
      "Optimal Layout Staging",
      "Affordable Room Makeovers",
      "Increases Room Spaciousness Vibe",
    ],
    process: [
      "Theme Consultation & Mood Boards",
      "Catalog Selection & Measuring",
      "Sourcing & Procurement",
      "On-site Installation & Setup",
      "Final Staging Review",
    ],
    projects: [],
    faqs: [
      {
        question: "Can you design decor around my existing furniture?",
        answer: "Absolutely. We specialize in blending current furniture items with new decor, colors, and accessories for a refreshed, updated look."
      }
    ],
  },

  // Plumbing Services
  {
    id: 11,
    slug: "plumbing-services",
    icon: FaWrench,
    title: "Plumbing Services",
    metaTitle: "Professional Plumbing Services in Indore | AZ Construction",
    metaDescription: "Expert residential & commercial plumbing in Indore. Concealed pipelines, sanitaryware installation, leak repairs, and pressure testing.",
    shortDescription: "Sanitary ware installations, concealed pipelines, and leak repairs.",
    bannerImage: "/images/services/plumbing-banner.png",
    image: "/images/services/plumbing.png",
    overview: "Secure a robust utility foundation. We offer certified plumbing solutions, including concealed water lines, drainage routing, sanitary ware installation, and water pump/tank setups with strict pressure-leak testing.",
    features: [
      "Concealed UPVC/CPVC Piping",
      "Luxury Sanitary Fitting Installation",
      "Drainage & Sewerage Systems",
      "Overhead Tank & Pressure Pumps",
      "Electronic Leak & Seepage Audits",
      "Water Softener & Filtration Setups",
    ],
    benefits: [
      "Zero Leakage Plumbing Layouts",
      "Corrosion-Free CPVC/UPVC Piping",
      "High Water Pressure Optimizations",
      "Experienced Certified Plumbers",
      "Timely & Clean Work Site",
      "Heavy-Duty Joint Fittings",
    ],
    process: [
      "Layout Drafting & Site Survey",
      "Wall Chipping & Pipe Laying",
      "Joint Fusion & Pressure Testing",
      "Plaster Cover-up & Tiling",
      "Sanitary Fit-out Installation",
    ],
    projects: [],
    faqs: [
      {
        question: "Why do you use CPVC/UPVC pipes instead of GI pipes?",
        answer: "CPVC/UPVC pipes are completely rust-proof, scales-resistant, lead-free, and last much longer than traditional GI pipes."
      },
      {
        question: "Do you perform pressure testing before closing walls?",
        answer: "Yes, we run hydrostatic pressure tests on all pipelines for 24 hours to ensure there are no microscopic joint leaks."
      }
    ],
  },

  // Steel & Aluminium Works
  {
    id: 12,
    slug: "steel-aluminium-works",
    icon: FaWindowMaximize,
    title: "Steel & Aluminium Works",
    metaTitle: "Steel & Aluminium Fabrication Services | AZ Construction",
    metaDescription: "Quality fabrication services in Indore. Aluminium sliding windows, UPVC window frames, steel safety gates, and glass partitions.",
    shortDescription: "Custom steel fabrication, sliding windows, and office glass partitions.",
    bannerImage: "/images/services/steel-aluminium-banner.png",
    image: "/images/services/steel-aluminium.png",
    overview: "Durable and modern metal works. We fabricate premium stainless steel safety gates, designer railings, powder-coated aluminium sliding window frames, UPVC window units, and office glass partitions.",
    features: [
      "Aluminium & UPVC Sliding Windows",
      "Designer Stainless Steel Railings",
      "Heavy-Duty Safety Gates & Grills",
      "Glass Partitions & Shower Cabins",
      "Structural Steel Truss & Sheds",
      "Laser-Cut CNC Metal Jali Works",
    ],
    benefits: [
      "High Durability & Weather Resistance",
      "Corrosion-Proof Coatings",
      "Modern Sleek Profiles",
      "Enhanced Home Security",
      "Excellent Sound & Heat Insulation",
      "Professional On-site Fitting",
    ],
    process: [
      "Precision Measurements & Templates",
      "Material Grade & Coating Choice",
      "Precision Factory Cutting & Welding",
      "Rust-Proof Painting or Polish",
      "Site Installation & Silicon Sealant",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you customize CNC laser-cut metal gates?",
        answer: "Yes, we design custom CNC laser-cut sheets in MS/SS for modern designer main gates, boundary walls, and interior partitions."
      }
    ],
  },

  // Smart Home Automation & Security
  {
    id: 13,
    slug: "smart-home-solutions",
    icon: FaShieldAlt,
    title: "Smart Home Automation",
    metaTitle: "Smart Home Automation & CCTV Security in Indore | AZ Construction",
    metaDescription: "Transform your home with smart solutions. App-controlled lighting, biometric lock installation, and HD CCTV surveillance setups.",
    shortDescription: "App-controlled smart lights, biometric door locks, and CCTV setups.",
    bannerImage: "/images/services/smart-home-banner.png",
    image: "/images/services/smart-home.png",
    overview: "Embrace modern living with intelligent home technology. We configure wireless automation modules, touch panels, smart biometric door locks, motion sensors, and high-definition CCTV camera systems controllable from your phone.",
    features: [
      "App & Voice Smart Light Switches",
      "Biometric & OTP Digital Locks",
      "IP CCTV Cameras & Video Doorbells",
      "Automated Curtain Controllers",
      "Motion & Gas Leak Sensors",
      "Home Theater Audio Integration",
    ],
    benefits: [
      "Maximum Home Safety & Monitoring",
      "Smart Energy Saving Controls",
      "Convenient Voice & App Operations",
      "Retrofit Modules (No Wall Tearing)",
      "Instant Mobile Security Alerts",
      "Premium Tech-Savvy Home Vibe",
    ],
    process: [
      "Automation & Security Consultation",
      "Wiring & Device Location Mapping",
      "Installing Smart Modules & Locks",
      "WiFi Configuring & Pairing",
      "User App Integration & Training",
    ],
    projects: [],
    faqs: [
      {
        question: "Can I control my smart home from outside?",
        answer: "Yes, all our automated systems and CCTV cameras are cloud-linked, letting you monitor and control them from anywhere in the world."
      }
    ],
  },

  // Solar & Green Energy Solutions
  {
    id: 14,
    slug: "solar-solutions",
    icon: FaSun,
    title: "Solar & Green Energy",
    metaTitle: "Solar Panel Installation Services in Indore | AZ Construction",
    metaDescription: "Reduce your electricity bill with high-efficiency solar panel installations. Commercial and residential solar net-metering in Indore.",
    shortDescription: "High-efficiency solar panel mounting, inverter hookups, and net metering.",
    bannerImage: "/images/services/solar-banner.png",
    image: "/images/services/solar.png",
    overview: "Save money while saving the planet. We plan, mount, and commission top-tier solar panel setups for rooftops, handling government net-metering paperwork and grid connections for continuous energy savings.",
    features: [
      "Residential Solar Rooftop Setups",
      "Commercial & Industrial Solar Power",
      "Net Metering Liasioning with DISCOM",
      "Monocrystalline High-Efficiency Panels",
      "Hybrid & Off-Grid Battery Setups",
      "Solar Water Heating Systems",
    ],
    benefits: [
      "Cuts Electricity Bills up to 90%",
      "Clean Renewable Energy",
      "Avail Government Solar Subsidies",
      "25+ Years Panel Lifespan",
      "Increases Property Valuation",
      "Minimal System Maintenance",
    ],
    process: [
      "Site Shadow Audit & Bill Analysis",
      "System Designing & Proposal",
      "Rooftop Mounting Frame Installation",
      "Solar Panel & Grid Inverter Setup",
      "Liaisoning, Testing, and Commissioning",
    ],
    projects: [],
    faqs: [
      {
        question: "How long does solar panel installation take?",
        answer: "The on-site installation takes 2-4 days, while the local DISCOM net-metering approvals can take about 2-3 weeks."
      }
    ],
  },

  // Modular Kitchen & Wardrobes
  {
    id: 15,
    slug: "modular-kitchen",
    icon: FaUtensils,
    title: "Modular Kitchen & Wardrobes",
    metaTitle: "Modular Kitchen & Wardrobes in Indore | AZ Construction",
    metaDescription: "Bespoke modular kitchen layouts and customized wardrobe designers in Indore. Soft-close drawers, acrylic cabinets, and pull-out trays.",
    shortDescription: "Bespoke modular kitchens, acrylic paneling, and sliding wardrobes.",
    bannerImage: "/images/services/kitchen-banner.png",
    image: "/images/services/kitchen.png",
    overview: "Cook in style. We manufacture and install ergonomic modular kitchen modules, custom pull-out baskets, high-gloss acrylic shutter sheets, and spacious sliding wardrobe units with soft-close mechanisms.",
    features: [
      "L-Shaped, U-Shaped, and Island Kitchens",
      "Waterproof BWR Plywood Cabinets",
      "Acrylic, PU, and Laminate Finishes",
      "Soft-Close Telescopic Drawer Slides",
      "Custom Fitted Sliding Wardrobes",
      "In-Built Pantry & Pull-out Baskets",
    ],
    benefits: [
      "Ergonomically Designed Storage",
      "Highly Resistant to Water & Heat",
      "Elegant Sleek Finish Options",
      "Quick Clean & Maintain Layouts",
      "Factory-Finished Custom Quality",
      "Smooth Soft-Close Operations",
    ],
    process: [
      "Detailed Layout Dimension Survey",
      "3D Color Visualizer Review",
      "Material & Laminate Choices",
      "Factory Cabinet Fabrication",
      "On-site Fitting & Appliances Hookup",
    ],
    projects: [],
    faqs: [
      {
        question: "Are modular kitchens waterproof?",
        answer: "We use Boiling Water Resistant (BWR) marine grade plywood for all kitchen framework, making them highly resistant to moisture and water damage."
      }
    ],
  },

  // Waterproofing Services
  {
    id: 16,
    slug: "waterproofing-services",
    icon: FaTintSlash,
    title: "Waterproofing Services",
    metaTitle: "Waterproofing & Leakage Control in Indore | AZ Construction",
    metaDescription: "Reliable waterproofing solutions in Indore. Roof, bathroom, basement waterproofing, chemical coating, and dampness repairs.",
    shortDescription: "Chemical waterproofing for roofs, bathrooms, basements, and walls.",
    bannerImage: "/images/services/waterproofing-banner.png",
    image: "/images/services/waterproofing.png",
    overview: "Stop seepage before it damages your walls. We provide premium chemical coatings, PU membranes, and pressure grouting to seal bathrooms, terraces, sumps, and basement walls from moisture and dampness.",
    features: [
      "Rooftop & Terrace Waterproofing",
      "Bathroom & Toilet Under-Tile Sealing",
      "Basement Concrete Injection Grouting",
      "Exterior Wall Acrylic Coatings",
      "Overhead & Sump Tank Waterproofing",
      "Dampness & Efflorescence Treatments",
    ],
    benefits: [
      "Stops Structural Concrete Corrosion",
      "Prevents Wall Paint Flaking & Mold",
      "Multi-Layer Elastomeric Coatings",
      "Up to 10 Years Waterproof Warranty",
      "Skilled Chemical Applicators",
      "Long-Lasting Sealing Barriers",
    ],
    process: [
      "Wall Seepage Check & Cleaning",
      "Grinding to Sound Concrete Base",
      "Polymer Crack Filling & Grouting",
      "Elastomeric Chemical Coating Layers",
      "72-Hour Water Ponding Test",
    ],
    projects: [],
    faqs: [
      {
        question: "How long does a waterproofing treatment last?",
        answer: "Our professional elastomeric chemical waterproofing treatments easily last 7 to 10 years, backed by our warranty."
      }
    ],
  },

  // Electrical & Wiring Solutions
  {
    id: 17,
    slug: "electrical-services",
    icon: FaBolt,
    title: "Electrical & Wiring",
    metaTitle: "Professional Electrical & Wiring in Indore | AZ Construction",
    metaDescription: "Safe house wiring, MCB panel installation, designer light fittings, and electrical load planning services in Indore.",
    shortDescription: "Internal wiring, MCB boards, safety earthing, and lighting installs.",
    bannerImage: "/images/services/electrical-banner.png",
    image: "/images/services/electrical.png",
    overview: "Powering your homes safely. We execute professional internal conduit layout wiring, load balancing, MCB distribution board installation, copper earthing, and designer lighting fixture mountings.",
    features: [
      "Concealed PVC Conduit Wiring",
      "MCB & RCCB Distribution Panels",
      "Copper Plate Safety Earthing Systems",
      "Designer Chandelier & Profile Lighting",
      "Inverter & UPS Backup Wiring",
      "Three-Phase Commercial Cable Laying",
    ],
    benefits: [
      "Maximum Fire & Short-Circuit Safety",
      "High-Grade Flame Retardant Wires",
      "Balanced Electrical Phase Loading",
      "Qualified Experienced Electricians",
      "Neat Wall Chipping & Finishing",
      "Secure Concealed Junction Boxes",
    ],
    process: [
      "Lighting & Switchboard Mapping",
      "Wall Chipping & Conduit Layout",
      "Cable Pulling & Wire Gauging",
      "Switchboard & Fixture Assemblies",
      "Megger Testing & Power Commissioning",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you install RCCB safety devices?",
        answer: "Yes, we install Residual Current Circuit Breakers (RCCBs) in all switchboards to protect against electric shocks and leakage currents."
      }
    ],
  },

  // ---------------------------------------------------------
  // LOCATION SEO PAGES (INDORE) FOR NEW SERVICES
  // ---------------------------------------------------------

  // Interior Designing in Indore
  {
    id: 105,
    slug: "interior-designing-company-in-indore",
    isLocationPage: true,
    icon: FaPencilRuler,
    title: "Interior Designing Company in Indore",
    metaTitle: "Best Interior Designing Company in Indore | AZ Construction",
    metaDescription: "Are you looking for the best interior designing company in Indore? AZ Construction provides custom 3D home interiors, modular kitchens, and premium space styling.",
    shortDescription: "Bespoke interior design, 3D space planning, and luxury home styling in Indore.",
    bannerImage: "/images/services/interior-banner.png",
    image: "/images/services/interior.png",
    overview: "As the top interior designing company in Indore, AZ Construction elevates your residential or commercial spaces. We specialize in designing modern villas, luxury apartments, and smart workspaces in Indore using 3D renders.",
    features: [
      "Space Planning in Indore Homes",
      "Modern 3D Room Renderings",
      "Custom Modular Kitchen Setups",
      "Sliding & Walk-In Wardrobes",
      "Ambient Lighting & Ceiling Layouts",
      "Commercial Showroom Interior Designs",
    ],
    benefits: [
      "Expert Indore-Based Design Team",
      "Tailor-made Styling Material Selection",
      "Maximum Space Optimization",
      "Transparent Pricing & Quality Materials",
      "Strict Execution Schedules",
      "On-Time Project Handover",
    ],
    process: [
      "Initial Consultation in Indore",
      "Design Concept Finalization",
      "High-Fidelity 3D Renderings",
      "Vendor Sourcing & Procurement",
      "Interior Fit-Out Execution",
      "Final Staging & Project Handover",
    ],
    projects: [],
    faqs: [
      {
        question: "Why choose AZ Construction for interior design in Indore?",
        answer: "We offer local design expertise, high-quality materials, and a transparent delivery process that guarantees a premium finish."
      }
    ],
  },

  // Renovation & Remodeling in Indore
  {
    id: 106,
    slug: "renovation-services-in-indore",
    isLocationPage: true,
    icon: FaHammer,
    title: "Renovation Services in Indore",
    metaTitle: "Best House & Building Renovation Services in Indore",
    metaDescription: "Give your home a premium makeover. AZ Construction offers complete kitchen, bathroom, and structural renovation services in Indore.",
    shortDescription: "Structural, home, kitchen, and bathroom renovation services in Indore.",
    bannerImage: "/images/services/renovation-banner.png",
    image: "/images/services/renovation.png",
    overview: "Transform your old house into a modern sanctuary. We provide end-to-end building renovation services in Indore, including bathroom remodeling, structural damp repairs, wall tearing, and beautiful elevation makeovers.",
    features: [
      "Full House Renovation in Indore",
      "Kitchen & Bathroom Remodeling",
      "Structural Repair & Plastering",
      "Modern Front Elevation Designing",
      "Balcony & Room Extensions",
      "Office Space Makeovers",
    ],
    benefits: [
      "Improves Local Property Market Value",
      "Repairs Hidden Dampness & Seepage",
      "Redesigns Outdated Room Flow",
      "Licensed Civil Contractors",
      "Premium Construction Material Grade",
      "Time-Bound Project Completion",
    ],
    process: [
      "On-site Inspection in Indore",
      "Concept Designing & Quotation",
      "Masonry dismantling & Disposal",
      "Structural Framework Updates",
      "Flooring, Fitting, and Painting",
      "Inspection & Handover",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you take up kitchen-only renovations in Indore?",
        answer: "Yes, we remodel individual kitchens and bathrooms to integrate modern fittings and modular layouts."
      }
    ],
  },

  // False Ceiling in Indore
  {
    id: 107,
    slug: "false-ceiling-services-in-indore",
    isLocationPage: true,
    icon: FaBorderAll,
    title: "False Ceiling Services in Indore",
    metaTitle: "Best False Ceiling Services (POP & PVC) in Indore",
    metaDescription: "Premium POP, PVC, and Gypsum false ceiling design and installation in Indore. Beautiful ambient LED lights and clean finishing.",
    shortDescription: "Expert POP, PVC, and Gypsum false ceiling installation in Indore.",
    bannerImage: "/images/services/false-ceiling-banner.png",
    image: "/images/services/false-ceiling.png",
    overview: "Get a modern look for your ceilings. AZ Construction offers professional POP, PVC, and Gypsum board false ceiling installation in Indore, complete with electrical channel layout and styling.",
    features: [
      "Designer POP Ceiling Installation in Indore",
      "Durable PVC Panel Ceilings",
      "Gypsum Board Ceilings for Offices",
      "Concealed COB & Strip Lighting",
      "Acoustic Sound Insulation Panels",
      "Designer Crown Moldings & Borders",
    ],
    benefits: [
      "Reduces Indore Summer Heat (Insulation)",
      "Improves Room Acoustic Sealing",
      "Conceals Unfinished Wiring & Pipes",
      "Creates Beautiful Modern Interiors",
      "Rust-Resistant Galvanized Frameworks",
      "Fast & Dust-Minimized Installation",
    ],
    process: [
      "Site Laser Level Survey",
      "Design & Grid Finalization",
      "Galvanized Iron Framing",
      "Board Screwing & Joint Plastering",
      "Putty Finishing & Sanding",
      "Final Painting & Light Cut-out",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you install PVC ceilings in Indore bathrooms?",
        answer: "Yes, PVC panels are ideal for bathrooms and kitchens in Indore as they are waterproof and do not warp."
      }
    ],
  },

  // Flooring Services in Indore
  {
    id: 108,
    slug: "flooring-services-in-indore",
    isLocationPage: true,
    icon: FaLayerGroup,
    title: "Flooring Services in Indore",
    metaTitle: "Top Tiling & Marble Flooring Services in Indore",
    metaDescription: "Professional tiling and Italian marble flooring installation in Indore. Marble polishing, vitrified tile laying, and wooden flooring.",
    shortDescription: "Tiling, marble, wooden, and granite flooring services in Indore.",
    bannerImage: "/images/services/flooring-banner.png",
    image: "/images/services/flooring.png",
    overview: "Premium tile and marble installations. AZ Construction delivers top-tier flooring services in Indore, ensuring perfect horizontal levels, uniform spacer joints, and beautiful shine for your home floors.",
    features: [
      "Vitrified Tiling in Indore Homes",
      "Italian & Indian Marble Laying",
      "Wooden Flooring for Bedrooms",
      "Granite Kitchen Platform Laying",
      "Heavy-Duty Epoxy Floor Coatings",
      "Mirror Polish Finishes for Marble",
    ],
    benefits: [
      "Perfect Level Alignment",
      "High Durability for Indore Traffic",
      "Wide Catalog of Ceramic & Vitrified",
      "Stain-Free Epoxy Grouting Joints",
      "Experienced Tiling Masons",
      "Flawless Shiny Floor Finishing",
    ],
    process: [
      "Floor Height & Slope Grading",
      "Pattern Aligning & Trimming",
      "Adhesive Cement Laying",
      "Tile Beating & Spacer Fitting",
      "Epoxy Grout Filling & Curing",
    ],
    projects: [],
    faqs: [
      {
        question: "Can you install marble flooring on existing tiles in Indore?",
        answer: "No, marble requires a strong base mortar and thickness. We recommend dismantling old tiles to prevent floor level rising."
      }
    ],
  },

  // Painting Services in Indore
  {
    id: 109,
    slug: "painting-services-company-in-indore",
    isLocationPage: true,
    icon: FaPaintRoller,
    title: "Painting Services Company in Indore",
    metaTitle: "Best Painting Services Company in Indore | Professional Painters",
    metaDescription: "Professional home painting services in Indore. AZ Construction offers premium interior, exterior, texture painting, and wood polishing.",
    shortDescription: "Premium house and commercial painting services in Indore.",
    bannerImage: "/images/services/paint-banner.png",
    image: "/images/services/paint.png",
    overview: "Get a fresh, vibrant look. We are a trusted painting services company in Indore providing dust-free wall preparation, primer applications, texture highlights, and weather-resistant external coatings.",
    features: [
      "Interior Emulsion Painting in Indore",
      "Weather-Shield Exterior Coatings",
      "Custom Textured Accent Walls",
      "Wall Putty Repairing & Primers",
      "Premium Wood PU Polishing",
      "Waterproofing Undercoats",
    ],
    benefits: [
      "Protects Indore Homes from Monsoon Seepage",
      "Highly Washable & Smooth Finishes",
      "Zero-VOC Eco-Friendly Paints Available",
      "Experienced Professional Painters",
      "Dust-Collector Machine Sanding",
      "Saves Wall Surface Prep Time",
    ],
    process: [
      "Covering Floors & Furniture",
      "Sanding Walls to Smooth Surface",
      "Putty & Base Primer Coating",
      "Emulsion Application (Double Coat)",
      "Quality Review & Masking Removal",
    ],
    projects: [],
    faqs: [
      {
        question: "How do you protect furniture during painting in Indore?",
        answer: "We cover all furniture, floors, and electronics with plastic drop sheets to protect them from paint splatters."
      }
    ],
  },

  // Home Decor in Indore
  {
    id: 110,
    slug: "home-decor-styling-in-indore",
    isLocationPage: true,
    icon: FaCouch,
    title: "Home Decor & Styling in Indore",
    metaTitle: "Best Home Decor & Styling Services in Indore | Interior Staging",
    metaDescription: "Complete home styling and decor in Indore. Premium wallpapers, custom curtains, modular furniture, and architectural lighting layouts.",
    shortDescription: "Premium wallpapers, customized curtains, designer lights, and furniture styling in Indore.",
    bannerImage: "/images/services/decor-banner.png",
    image: "/images/services/decor.png",
    overview: "Create a luxurious space. AZ Construction provides exclusive home decor and interior styling services in Indore, sourcing high-end curtains, wallpapers, lighting, and decorative accessories.",
    features: [
      "Imported Wallpaper Application in Indore",
      "Designer Curtains & Roman Blinds",
      "Custom Furniture & Layout Staging",
      "Profile & Decorative Accent Lights",
      "Wall Art & Frame Installations",
      "Luxury Home Accessories Consultations",
    ],
    benefits: [
      "Custom Decor Themes (Modern/Vintage)",
      "Cohesive Room Layout Alignment",
      "Direct Wholesale Sourcing in Indore",
      "Hassle-free Procurement & Setups",
      "Elevated Space Aesthetics",
      "Personalized Stylist Consultant",
    ],
    process: [
      "In-Home Design & Theme Briefing",
      "Theme Selection & Dimension Measurements",
      "Purchasing Coordination",
      "Site Installation & Custom Fitting",
      "Final Staging Check",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you help with custom curtain stitchings in Indore?",
        answer: "Yes, we take precise window measurements, supply designer fabric catalogs, and install stitched curtains with tracks."
      }
    ],
  },

  // Plumbing Services in Indore
  {
    id: 111,
    slug: "plumbing-services-in-indore",
    isLocationPage: true,
    icon: FaWrench,
    title: "Plumbing Services in Indore",
    metaTitle: "Reliable Plumbing Services in Indore | Toilet & Pipe Fitting",
    metaDescription: "Professional plumbing services in Indore. Concealed CPVC pipeline routing, leak repairs, pressure audits, and sanitary fittings.",
    shortDescription: "Certified pipeline routing, leak repair, and sanitary fitting services in Indore.",
    bannerImage: "/images/services/plumbing-banner.png",
    image: "/images/services/plumbing.png",
    overview: "Expert plumbing solutions. AZ Construction offers reliable plumbing services in Indore for residential and commercial structures, ensuring safe drainage routing and high pressure performance.",
    features: [
      "Concealed CPVC/UPVC Piping in Indore",
      "Luxury Sanitary & Tap Fittings",
      "Rainwater & Sewerage Pipeline Routing",
      "Overhead Water Tank Clean & Installs",
      "Acoustic Silent Drainage Piping",
      "RO & Geyser Connection Installs",
    ],
    benefits: [
      "Zero Leakage Plumbing Performance",
      "High Durability Non-Corrosive Pipes",
      "Perfect Pressure Distribution Layouts",
      "Licensed Plumbing Mechanics",
      "Hydrostatic Leak Testing Protocols",
      "Quick Emergency Response Sump Fixes",
    ],
    process: [
      "Blueprints & Site Surveying",
      "Wall Cutting & Conduit Fixing",
      "Joint Weld & Pressure Leakage Verification",
      "Wall Cement Closure",
      "Final Sanitaries Fitments",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you fix leakage seepage issues in Indore?",
        answer: "Yes, we identify pipe fractures under plaster using modern tools and repair them quickly to stop seepage."
      }
    ],
  },

  // Steel & Aluminium Works in Indore
  {
    id: 112,
    slug: "steel-aluminium-works-in-indore",
    isLocationPage: true,
    icon: FaWindowMaximize,
    title: "Steel & Aluminium Works in Indore",
    metaTitle: "Best Steel & Aluminium Fabrication Company in Indore",
    metaDescription: "Top steel and aluminium fabrication in Indore. Stainless steel railings, UPVC windows, sliding glass doors, and safety gates.",
    shortDescription: "Premium fabrication, sliding windows, and office partitions in Indore.",
    bannerImage: "/images/services/steel-aluminium-banner.png",
    image: "/images/services/steel-aluminium.png",
    overview: "Modern metal fabrication in Indore. AZ Construction manufactures and installs durable sliding windows, heavy safety gates, and glass cabin partitions across Indore.",
    features: [
      "Aluminium Sliding Windows in Indore",
      "Stainless Steel Balcony Railings",
      "CNC Laser-Cut Steel Security Gates",
      "UPVC Window Frameworks",
      "Commercial Glass Cabin Partitions",
      "Industrial Tin Shed Fabrication",
    ],
    benefits: [
      "Premium Grade Rust-Proof Metals",
      "Precision Welding & Smooth Finishes",
      "Enhanced Security for Indore Properties",
      "Excellent Weather & Sound Insulation",
      "Experienced Metal Fitters",
      "Custom Designs Tailored to Blueprint",
    ],
    process: [
      "Site Measurement & Detail Sketch",
      "Material Sourcing & Grade Check",
      "Workshop Cutting & Frame Fabrication",
      "Anti-Rust Coating/Polishing",
      "Site Installation & Silicon Sealant",
    ],
    projects: [],
    faqs: [
      {
        question: "What grade of steel do you use for railings in Indore?",
        answer: "We use premium SS 304 grade steel for exterior railings to prevent rusting during Indore's monsoon season."
      }
    ],
  },

  // Smart Home Automation in Indore
  {
    id: 113,
    slug: "smart-home-automation-in-indore",
    isLocationPage: true,
    icon: FaShieldAlt,
    title: "Smart Home Automation in Indore",
    metaTitle: "Smart Home Automation & Security Systems in Indore",
    metaDescription: "Upgrade to a smart home. App-controlled lighting, CCTV security systems, and digital biometric door lock installation in Indore.",
    shortDescription: "Smart lighting, biometric locks, and security camera installations in Indore.",
    bannerImage: "/images/services/smart-home-banner.png",
    image: "/images/services/smart-home.png",
    overview: "Get smart home solutions in Indore. AZ Construction designs and installs IoT smart switches, security systems, smart video doorbells, and wireless home automation modules.",
    features: [
      "Smart Light & AC Control in Indore",
      "Digital Biometric Door Lock Installations",
      "HD CCTV Camera Security Setups",
      "Voice Controls (Alexa/Google Assistant)",
      "Gas Leak & Motion Sensors",
      "Automated Motorized Curtains",
    ],
    benefits: [
      "Complete Mobile App Access Controls",
      "Reduces Electricity Consumption",
      "Alerts Against Break-Ins",
      "Retrofit Modules (No Damage to Wall)",
      "Intelligent High-Tech Living Vibe",
      "Professional System Setup",
    ],
    process: [
      "In-Home Automation Audit",
      "Wiring & Device Location Mapping",
      "Installing Smart Locks & CCTV Units",
      "Configuring Smart Hubs & Apps",
      "Client Training & Handover",
    ],
    projects: [],
    faqs: [
      {
        question: "Is WiFi required for smart home systems in Indore?",
        answer: "Yes, a stable home WiFi connection is necessary to control devices remotely from your mobile app."
      }
    ],
  },

  // Solar Solutions in Indore
  {
    id: 114,
    slug: "solar-panel-installation-in-indore",
    isLocationPage: true,
    icon: FaSun,
    title: "Solar Panel Installation in Indore",
    metaTitle: "Top Solar Panel Installation Company in Indore | Net Metering",
    metaDescription: "Looking for solar panel installation in Indore? AZ Construction provides high-efficiency solar panel setups, DISCOM net-metering, and grid setup.",
    shortDescription: "Rooftop solar panel design, mounting, and net metering in Indore.",
    bannerImage: "/images/services/solar-banner.png",
    image: "/images/services/solar.png",
    overview: "Switch to clean energy in Indore. We provide commercial and residential solar panel installation in Indore, managing all approvals and grid-tie net-metering installations.",
    features: [
      "Residential Solar Panel Fitting in Indore",
      "Commercial Solar Plant Setups",
      "MPEB (DISCOM) Net Meter Metering Approvals",
      "High-Efficiency Rooftop Solar Mounts",
      "Off-Grid Battery Solar Panels",
      "Solar Water Heating Systems",
    ],
    benefits: [
      "Reduces Electricity Bills by up to 90%",
      "Eco-Friendly Green Power Source",
      "Assistance with Govt. Rooftop Subsidies",
      "Robust Structure Built for Indore Winds",
      "Long System Lifespan (25+ Years)",
      "Increases Home Resell Value",
    ],
    process: [
      "Rooftop Area Survey & Consumption Audit",
      "System Size Designing & Quotation",
      "Mounting Frame Structure Installation",
      "Solar Panel Hookup & Inverter Cabling",
      "DISCOM Net Meter Testing & Commissioning",
    ],
    projects: [],
    faqs: [
      {
        question: "Can I get a government subsidy on solar in Indore?",
        answer: "Yes, residential solar installations in Indore are eligible for central and state solar subsidy schemes, and we assist you with the application."
      }
    ],
  },

  // Modular Kitchen in Indore
  {
    id: 115,
    slug: "modular-kitchen-designers-in-indore",
    isLocationPage: true,
    icon: FaUtensils,
    title: "Modular Kitchen Designers in Indore",
    metaTitle: "Best Modular Kitchen Designers in Indore | Custom Wardrobes",
    metaDescription: "Top modular kitchen designers in Indore. AZ Construction offers modern U-shaped, L-shaped kitchens, sliding wardrobes, and premium finishes.",
    shortDescription: "Customized modular kitchen and wardrobe designing in Indore.",
    bannerImage: "/images/services/kitchen-banner.png",
    image: "/images/services/kitchen.png",
    overview: "Design your dream kitchen in Indore. We are the premier modular kitchen designers in Indore, manufacturing termite-proof and waterproof cabinets with acrylic coatings and soft-close pullout baskets.",
    features: [
      "L-Shaped & Parallel Kitchens in Indore",
      "Waterproof BWR Plywood Frameworks",
      "High-Gloss Acrylic Cabinet Finishings",
      "Soft-Close Telescopic Drawer Hinges",
      "Custom Fitted Sliding Wardrobes",
      "Pantry Tall Units & Chimney Installs",
    ],
    benefits: [
      "Ergonomically Structured Storage Layouts",
      "Highly Resistant to Indore Heat & Moisture",
      "Elegant Sleek Finish Options",
      "Quick Clean & Maintain Surfaces",
      "Factory-Precision Custom Fabrication",
      "Soft-Close Operations on All Drawers",
    ],
    process: [
      "Detailed Layout Dimension Survey",
      "3D Layout Rendering & Color Preview",
      "Laminate & Hardware Catalog Choices",
      "Factory Panel Processing",
      "Site Fitment & Appliances Connection",
    ],
    projects: [],
    faqs: [
      {
        question: "How long does modular kitchen installation in Indore take?",
        answer: "Fabrication in the factory takes 10 to 15 days, and final assembly at your site in Indore takes 2 to 3 days."
      }
    ],
  },

  // Waterproofing in Indore
  {
    id: 116,
    slug: "waterproofing-services-in-indore",
    isLocationPage: true,
    icon: FaTintSlash,
    title: "Waterproofing Services in Indore",
    metaTitle: "Best Waterproofing Services in Indore | Seepage Control",
    metaDescription: "Professional waterproofing services in Indore. Chemical wall coating, terrace waterproofing, basement injection, and leak repair.",
    shortDescription: "Terrace, basement, toilet, and wall chemical waterproofing in Indore.",
    bannerImage: "/images/services/waterproofing-banner.png",
    image: "/images/services/waterproofing.png",
    overview: "Protect your walls from damage. AZ Construction offers professional waterproofing services in Indore, using chemical coatings and injection grouting to stop bathroom, roof, and basement leaks.",
    features: [
      "Terrace & Balcony Waterproofing in Indore",
      "Bathroom Under-Tile Sealings",
      "Basement Concrete Injection Grouting Sealing",
      "Exterior Wall Crack Waterproof Coatings",
      "Water Tank Seepage Treatment Services",
      "Wall Dampness & Fungus Treatments",
    ],
    benefits: [
      "Stops Damaging Concrete Corrosion",
      "Prevents Flaking Paint & Ugly Wall Stains",
      "Flexible Elastomeric Polymer Coatings",
      "Up to 10 Years Waterproof Warranty",
      "Experienced Chemical Applicators",
      "Seamless Durable Sealing Barrier",
    ],
    process: [
      "Site Moisture Audit & Cleaning",
      "Grinding Wall to Concrete Base",
      "Polymer Crack Filling & Repairs",
      "Applying Multi-layer Elastomeric Coats",
      "72-Hour Leak Ponding Verification",
    ],
    projects: [],
    faqs: [
      {
        question: "Why does my wall paint flake in Indore?",
        answer: "Wall paint flakes due to moisture and water seepage. Professional chemical waterproofing seals the brickwork to stop this dampness."
      }
    ],
  },

  // Electrical in Indore
  {
    id: 117,
    slug: "electrical-wiring-services-in-indore",
    isLocationPage: true,
    icon: FaBolt,
    title: "Electrical Wiring Services in Indore",
    metaTitle: "Best Electrical Wiring & Fitting Services in Indore",
    metaDescription: "Safe house wiring and electrical fitting in Indore. Concealed PVC conduit piping, MCB panel installation, and lighting layouts.",
    shortDescription: "Professional internal wiring, MCB boards, and safety earthing in Indore.",
    bannerImage: "/images/services/electrical-banner.png",
    image: "/images/services/electrical.png",
    overview: "Safe and secure electrical wiring. We offer professional house wiring services in Indore, installing fire-resistant cables, MCB distribution boxes, earthing setups, and designer lights.",
    features: [
      "Concealed conduit PVC wiring in Indore",
      "MCB & RCCB Shock-Protection Panels",
      "Safety Earthing & Lightning Arrester installs",
      "Profile Light & Chandelier Fitting Assemblies",
      "Inverter & Backup Battery Wiring",
      "Industrial Three-Phase Cable Laying",
    ],
    benefits: [
      "Shock & Fire-Safe Internal Installations",
      "Premium Grade Copper Cables (Polycab/Havells)",
      "Balanced Electrical Phase Load Design",
      "Experienced Certified Electrician Crews",
      "Clean Conduit Wall Chipping",
      "Concealed Switchboxes Layouts",
    ],
    process: [
      "Site Blueprint Point Allocation",
      "Wall Chipping & Conduit Framing",
      "Cable Pulling & Continuity Testing",
      "Switchboard Plate & Light Fitting Mountings",
      "Phase Load Balance & Megger Auditing",
    ],
    projects: [],
    faqs: [
      {
        question: "Do you install earthing systems for houses in Indore?",
        answer: "Yes, we install chemical and copper-plate earthing systems to protect your electronics and family from voltage surges."
      }
    ],
  },
];